'use client'

import textDisplayL from '@fukku/styles/texts/textDisplayL.module.css'
import textHeadingL from '@fukku/styles/texts/textHeadingL.module.css'
import textInspirationalTitleL from '@fukku/styles/texts/textInspirationalTitleL.module.css'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import {
	type HeroBannerPromo,
	HeroBannerPromoType,
} from '../../../../Home.type'
import styles from './HeroBannerPromoFamily.module.css'

interface HeroBannerPromoFamilyProps {
	readonly section: HeroBannerPromo
}

export function HeroBannerPromoFamily({ section }: HeroBannerPromoFamilyProps) {
	const { isLargeOrGreater } = useResponsive()
	if (section.promoType !== HeroBannerPromoType.family) {
		return null
	}

	const {
		familyPromoTitles: { title, subtitle },
	} = section

	return (
		<div className={styles.titles}>
			<h2 className={styles.titlesWrapper}>
				<div className={textInspirationalTitleL.className}>{title}</div>
				<div
					className={
						isLargeOrGreater ? textDisplayL.className : textHeadingL.className
					}
				>
					{subtitle}
				</div>
			</h2>
		</div>
	)
}
